import { component } from 'vuets';
export var Home = (function () {
    function Home() {
        this.msg = 'Home';
        this.activate = 0;
        this.deactivate = 0;
    }
    Home.activate = function (self) {
        self.activate++;
    };
    Home.deactivate = function (self) {
        self.deactivate++;
        return true;
    };
    Home.prototype.append = function (suffix) {
        this.msg += suffix;
    };
    return Home;
}());
export default component({
    template: "\n<div>\n  <h3 @click=\"append('!')\">{{ msg }}</h3>\n  <div>\n    activate count: {{ activate }} | deactivate count: {{ deactivate }}\n  </div>\n</div>\n"
}, Home, Home.activate, Home.deactivate);



//////////////////
// WEBPACK FOOTER
// ./src/home/index.ts
// module id = 3
// module chunks = 0